module.exports = __webpack_public_path__ + "static/img/06004B_4_R_20230325_LC.d9d1fe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/06004B_4_R_20230325_LC.png
// module id = 6Cfr
// module chunks = 0